import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  more_info: 'More info',
  labels: {
    available: 'Available',
    unavailable: 'Unavailable',
  },
  buttons: {
    order_now: 'Order Now',
  },
  order_method_info: {
    fee: {
      [ORDER_METHODS.PICKUP]: 'Pickup: {{fee}}',
      [ORDER_METHODS.DELIVERY]: 'Delivery: {{fee}}',
      [ORDER_METHODS.ROOM_SERVICE]: 'On site: {{fee}}',
      [ORDER_METHODS.DINE_IN]: 'On site: {{fee}}',
    },
    min_order: 'MIN: {{minOrder}}',
  },
  preparation_time: 'Ready in {{time}} min or schedule for later',
};
